import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BootstrapCompatibilityService {

  constructor() { }

  // Initialize Bootstrap 4 to Bootstrap 5 compatibility
  initializeCompatibility() {
    // Convert data-toggle to data-bs-toggle for Bootstrap 5
    this.convertDataAttributes();
    
    // Initialize Bootstrap 5 components
    this.initializeBootstrapComponents();
  }

  private convertDataAttributes() {
    // Convert data-toggle="collapse" to data-bs-toggle="collapse"
    const toggleElements = document.querySelectorAll('[data-toggle="collapse"]');
    toggleElements.forEach(element => {
      const toggle = element.getAttribute('data-toggle');
      const target = element.getAttribute('data-target');
      
      if (toggle) {
        element.setAttribute('data-bs-toggle', toggle);
        element.removeAttribute('data-toggle');
      }
      
      if (target) {
        element.setAttribute('data-bs-target', target);
        element.removeAttribute('data-target');
      }
    });

    // Convert other data-toggle attributes
    const dropdownElements = document.querySelectorAll('[data-toggle="dropdown"]');
    dropdownElements.forEach(element => {
      element.setAttribute('data-bs-toggle', 'dropdown');
      element.removeAttribute('data-toggle');
    });

    const modalElements = document.querySelectorAll('[data-toggle="modal"]');
    modalElements.forEach(element => {
      element.setAttribute('data-bs-toggle', 'modal');
      element.removeAttribute('data-toggle');
    });

    const tooltipElements = document.querySelectorAll('[data-toggle="tooltip"]');
    tooltipElements.forEach(element => {
      element.setAttribute('data-bs-toggle', 'tooltip');
      element.removeAttribute('data-toggle');
    });
  }

  private initializeBootstrapComponents() {
    // Initialize Bootstrap 5 components after DOM is ready
    setTimeout(() => {
      // Initialize tooltips
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new (window as any).bootstrap.Tooltip(tooltipTriggerEl);
      });

      // Initialize dropdowns
      const dropdownElementList = [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]'));
      dropdownElementList.map(function (dropdownToggleEl) {
        return new (window as any).bootstrap.Dropdown(dropdownToggleEl);
      });
    }, 100);
  }

  // Call this method when navigating to new routes
  refreshCompatibility() {
    setTimeout(() => {
      this.initializeCompatibility();
    }, 500);
  }

  // Initialize Bootstrap 5 accordion functionality
  initializeAccordions() {
    // Wait for DOM to be ready and let Bootstrap 5 handle accordion functionality natively
    setTimeout(() => {
      this.setupAccordionStates();
    }, 100);
  }

  private setupAccordionStates() {
    // Find all Bootstrap 5 accordion buttons and ensure proper initial state
    const accordionButtons = document.querySelectorAll('[data-bs-toggle="collapse"]');
    
    accordionButtons.forEach((button) => {
      const htmlButton = button as HTMLElement;
      
      // Initialize button state based on target element
      const targetSelector = htmlButton.getAttribute('data-bs-target');
      if (targetSelector) {
        const targetElement = document.querySelector(targetSelector) as HTMLElement;
        if (targetElement) {
          // Set initial state based on target element
          const isExpanded = targetElement.classList.contains('show');
          if (isExpanded) {
            htmlButton.classList.remove('collapsed');
            htmlButton.setAttribute('aria-expanded', 'true');
          } else {
            htmlButton.classList.add('collapsed');
            htmlButton.setAttribute('aria-expanded', 'false');
          }
        }
      }
    });
    
    // Let Bootstrap 5 handle the accordion functionality natively
    // No custom event handlers needed
  }

  // Call this when new content is loaded (e.g., after route changes)
  refreshAccordions() {
    setTimeout(() => {
      this.initializeAccordions();
    }, 200);
  }
} 